import React from 'react';
import Empty from '../components/Empty';

function RouteNotFound() {
  return <Empty title="The resource requested cannot be found on this server!" />;
}

export default RouteNotFound;
